import Source from "./models/Source";
import Layer from "./models/Layer";

var GJV = require("geojson-validation");

export default class DataManager {
    constructor(context) {

        this.okanMap = context;

        this.dataApiUrl = 'http://data.okan3d.com'
    }

    getData(url, callback) {

        if(url == null)
            url = 'data/examples/points.geojson'

        $.getJSON( url, ( data ) => {
            
            if(GJV.valid(data)){
                callback(data);
            }
            else {
                callback(null);
            }

        }).fail((e, v =null) => {
            console.log( "error", e );
            console.log( "error details", v );
        });

    }

    getDataFromSource(source, callback){
       
        //TODO : data provider id to get data

        var url = 'data/examples/points.geojson'

        if(source.provider.id == 1) {
            switch(source.datasetId) {
                case 1:
                    url = 'data/examples/polys.geojson'
                    break;
                case 2:
                    url = 'data/examples/lines.geojson'
                    break;
                case 3:
                    url = 'data/examples/points.geojson'
                    break;
                case 4:
                    url = 'data/examples/mixed.geojson'
                    break;
            }
        }
        else if(source.provider.id == 2) {
            switch(source.datasetId) {
                case 1:
                    url = 'data/datatoursime/hotels.geojson'
                    break;
                case 2:
                    url = 'data/datatoursime/events.geojson'
                    break;
                case 3:
                    url = 'data/datatoursime/restos.geojson'
                    break;
            }
        }
        else if(source.provider.id == 3) {
            switch(source.datasetId) {
                case 1:
                    url = 'data/datagouv/communautes_de_communes_aube.json'
                    break;
                case 2:
                    url = 'data/datagouv/communes_aube.json'
                    break;
                case 3:
                    url = 'data/datagouv/communes_france.json'
                    break;
            }
        }

        console.log('url to load: ', url)

        this.getData(url, (data) => {
            console.log('data retreived', data)
            callback(data)
        })


    }

    // CURRENTLY NOT USED
    getDatasetStructure(source, callback) {
        var propertiesList = []
        for(var attr in source.data.features[0].properties) {
            propertiesList.push(attr)
        }

        return new Promise(resolve => {

            
            setTimeout(() => {
                /*callback([
                    'Latitude',
                    'Longitude',
                    'Name',
                    'AllowedPersons',
                    'Description',
                    'Creation date'
                ])*/
                callback(propertiesList)
            }, 500);
        });

    }

    getProviders() {

        return [
            {
                id: 1,
                name: 'OKENITE',
                url: 'https://okenite.xyz',
                logo : 'http://okan3d.com/wp-content/themes/okenitexyz/img/okenite_small.png',
                datasets : [
                    {
                        id: 1,
                        name : 'Test Polygones',
                        nb_points: 3
                    },
                    {
                        id: 2,
                        name : 'Test Lines',
                        nb_points: 3
                    },
                    {
                        id: 3,
                        name : 'Test Points',
                        nb_points: 20
                    }/*,
                    {
                        id: 4,
                        name : 'Test Mixed',
                        nb_points: 98000
                    }*/
                ]
            },
            {
                id: 2,
                name: 'Datatourisme',
                url: 'https://www.datatourisme.gouv.fr',
                logo : 'https://www.datatourisme.gouv.fr/assets/images/logos/datatourisme-250.png',
                datasets : [
                    {
                        id: 1,
                        name : 'Hotels',
                        nb_points: 98
                    },
                    {
                        id: 2,
                        name : 'Events',
                        nb_points: 944
                    },
                    {
                        id: 3,
                        name : 'Restaurants',
                        nb_points: 392
                    }
                ]
            },
            {
                id: 3,
                name: 'data.gouv',
                url: 'https://www.data.gouv.fr',
                logo : 'https://static.data.gouv.fr/_themes/gouvfr/img/logo-header.svg',
                datasets : [
                    {
                        id: 1,
                        name : "Communautes de communes de l'Aube",
                        nb_points: 24
                    },
                    {
                        id: 2,
                        name : "Communes de l'Aube",
                        nb_points: 433
                    },
                    {
                        id: 3,
                        name : 'Communes de France',
                        nb_points: 36570
                    }
                ]
            },
            {
                id: 4,
                name: 'Emploi Store',
                url: 'https://www.emploi-store-dev.fr',
                logo : 'https://www.emploi-store-dev.fr/portail-developpeur/assets/4.6.52-64/ctx/dist/images/logo-esd.svg',
                datasets : []
            },
            {
                id: 5,
                name: 'DATA.GOV',
                url: 'https://www.data.gov',
                logo : 'https://www.data.gov/app/themes/roots-nextdatagov/assets/img/logo.svg',
                datasets : []
            },
            {
                id: 6,
                name: 'NASA',
                url: 'https://data.nasa.gov/',
                logo : 'https://data.nasa.gov/api/assets/101AE2CD-4D6B-45E2-B2D6-30B36F639398',
                datasets : []
            }
        ];
    }

    init() {

    }

    /*
    Called when new file upload

    */
    HandleNewFile(content, extension, filename) {

        var newGeoJsonContent = null;
        var error = false;

        var source = new Source();
        source.name = filename;

        source.fromFile = true;
        source.needsLatLongInfo = true;

        extension = extension.toLowerCase().trim();

        if( ['json', 'geojson' ].includes(extension) ) {

            var newObject = null;
            try {
                newObject = JSON.parse(content);
            }
            catch(er) {
                console.log("error: can't parse object");
                console.log(er);
                error = true;
            }

            if(newObject != null && !error ) {

                if(GJV.valid(newObject)){

                    console.log("this is valid GeoJSON!");

                    source.needsLatLongInfo = false;
                    source.data = newObject;
                    source.ready = true;
                    source.originalContentType = 'geojson';

                    

                }
                else {

                    if(extension == 'geojson') {

                        console.log("this not a valid GeoJSON!");

                        error = true;

                    }
                    else { // on continue

                        console.log("this a json object");

                        source.originalContent = newObject;
                        source.originalContentType = 'json';

                    }

                }

            }  

        }
        else if (extension == 'csv') {
            console.log("this is a .csv file");

            var newObject = content; //TODO: csv to object

            source.originalContentType = 'csv';
            source.originalContent = newObject;
        }
        else {
            error = true;
        }


        return {
            success : !error,
            source : source
        }
    }

    splitSourceForTypes(source) {
        var arrayPoints = source.data.features.filter(x => x.geometry.type.toLowerCase().trim() == 'point');
        var arrayPolys = source.data.features.filter(x => x.geometry.type.toLowerCase().trim() == 'polygon');
        var arrayLines = source.data.features.filter(x => x.geometry.type.toLowerCase().trim() == 'linestring');

        var output = []
        if(arrayPoints.length > 0 ) {
            let pointSource = new Source()
            pointSource.name = source.name + ' : POIs'
            pointSource.id = this.okanMap.uniqueId();
            pointSource.providerId = 2;
            pointSource.datasetId = 1;
            pointSource.ready = true; 
            pointSource.data = {
                type: "FeatureCollection",
                features: arrayPoints
            };
            output.push(pointSource)
        }
        if(arrayPolys.length > 0 ) {
            let pointPolys = new Source()
            pointPolys.name = source.name + ' : Zones'
            pointPolys.id = this.okanMap.uniqueId();
            pointPolys.providerId = 2;
            pointPolys.datasetId = 1;
            pointPolys.ready = true; 
            pointPolys.data = {
                type: "FeatureCollection",
                features: arrayPolys
            };
            output.push(pointPolys)
        }
        if(arrayLines.length > 0 ) {
            let pointLines = new Source()
            pointLines.name = source.name + ' : Lines'
            pointLines.id = this.okanMap.uniqueId();
            pointLines.providerId = 2;
            pointLines.datasetId = 1;
            pointLines.ready = true; 
            pointLines.data = {
                type: "FeatureCollection",
                features: arrayLines
            };
            output.push(pointLines)
        }

        console.log(output)

        return output;
    }

    createLayersFromSource(source, sourceIndex) {
        var arrayPoints = source.data.features.filter(x => x.geometry.type.toLowerCase().trim() == 'point');
        var arrayPolys = source.data.features.filter(x => x.geometry.type.toLowerCase().trim() == 'polygon');
        var arrayLines = source.data.features.filter(x => x.geometry.type.toLowerCase().trim() == 'linestring');

        var layers = []

        if(arrayPoints.length > 0 ) {
            var pointLayer = new Layer();
            pointLayer.id = this.okanMap.uniqueId();
            pointLayer.name = source.name + ' : Points';
            pointLayer.typeIndex = 0;
            pointLayer.sourceIndex = sourceIndex;

            layers.push(pointLayer);

        }

        if(arrayPolys.length > 0 ) {
            var polyLayer = new Layer();
            polyLayer.id = this.okanMap.uniqueId();
            polyLayer.name = source.name + ' : Polygons';
            polyLayer.typeIndex = 1;
            polyLayer.sourceIndex = sourceIndex;

            layers.push(polyLayer);

        }

        if(arrayLines.length > 0 ) {
            var linesLayer = new Layer();
            linesLayer.id = this.okanMap.uniqueId();
            linesLayer.name = source.name + ' : Lines';
            linesLayer.typeIndex = 2;
            linesLayer.sourceIndex = sourceIndex;

            layers.push(linesLayer);

        }


        return layers;


    }

}